module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Language"},"es":{"label":"Lengua"},"fr":{"label":"Langue"},"it":{"label":"Lingua"},"pt":{"label":"Idioma"},"pl":{"label":"Język"}}')
  delete Component.options._Ctor
}
